import React from 'react'
import hash from '@emotion/hash'

import { Paragraph, ParagraphProps } from './Paragraph'

export type ParagraphsProps = {
  items: ParagraphProps[]
  nonUrlText: any
}

export const Paragraphs = ({ items, nonUrlText }: ParagraphsProps) => (
  <>
    {items.map((item) => (
      <Paragraph
        key={hash(Object.values(item).join('#'))}
        {...item}
        nonUrlText={nonUrlText}
      />
    ))}
  </>
)
export default Paragraphs
